export const header = {
    french: {
        title: "Nicolas Duquesne"
    },
    link: "/"
}